import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { getTravelDocumentKindsOptions } from '../../model/TravelRequestQuery';
import {
  TravelRequest,
  hasTravelMobilitySupport,
  travelReturnGroupLabel,
  travelReturnOneOfGroups,
} from '../../model/TravelRequestTypes';
import { DocumentChecklist, DocumentChecklistRow } from './TravelRequestDocumentChecklist';

interface TravelRequestReturnChecklistProps {
  request: TravelRequest;
}

export function TravelRequestReturnChecklist({ request }: TravelRequestReturnChecklistProps) {
  const { t } = useTranslation();
  const { data } = useQuery(getTravelDocumentKindsOptions(request.activityType, hasTravelMobilitySupport(request)));

  const returnRequired = data?.returnRequired ?? [];
  const groups = data == null ? [] : travelReturnOneOfGroups(data);
  if (data == null || (returnRequired.length === 0 && groups.length === 0)) {
    return null;
  }

  const uploadedKinds = new Set(request.files.map(file => file.kind));
  const rows: DocumentChecklistRow[] = [
    ...returnRequired.map(kind => ({
      kind,
      required: true,
      uploaded: uploadedKinds.has(kind),
      hint: 'documentReturnRequired' as const,
    })),
    ...groups.map(group => ({
      kind: group[0],
      label: travelReturnGroupLabel(t, group, request.activityType),
      required: true,
      uploaded: group.some(kind => uploadedKinds.has(kind)),
      hint: 'documentReturnRequired' as const,
    })),
  ];

  return (
    <DocumentChecklist
      title={t('travel.requests.view.returnDocumentsChecklist')}
      rows={rows}
      guidance={data.returnGuidance}
      activityType={request.activityType}
    />
  );
}
